import type { ApexOptions } from 'apexcharts';
import { ACCENT_COLORS } from '@/constants/colors';

export const CHIP_OFFSET = 12;

export const CHIP_HEADROOM = 1.15;

export const DATA_LABEL_CHIP = {
  offsetY: -CHIP_OFFSET,
  style: { fontSize: '10.5px', fontWeight: 700, colors: ['#ffffff'] },
  background: {
    enabled: true,
    foreColor: ACCENT_COLORS.taupe,
    borderRadius: 6,
    padding: 5,
    borderWidth: 1,
    borderColor: 'rgba(70, 60, 50, 0.1)',
    opacity: 1,
    dropShadow: { enabled: true, top: 3, left: 0, blur: 8, opacity: 0.25 },
  },
};

// ApexCharts paints column gradients from the baseline up, so the bottom stop is the series colour.
export const BAR_GRADIENT = {
  brand: {
    bottom: ACCENT_COLORS.gradientEnd,
    top: ACCENT_COLORS.gradientStart,
  },
  teal: {
    bottom: ACCENT_COLORS.tealGradientEnd,
    top: ACCENT_COLORS.tealGradientStart,
  },
};

export const DEFAULT_CHART_OPTIONS: ApexOptions = {
  chart: {
    toolbar: { show: false },
    zoom: { enabled: false },
    animations: { dynamicAnimation: { enabled: false } },
  },
  dataLabels: {
    enabled: true,
    style: { fontSize: '11px' },
  },
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
    active: {
      allowMultipleDataPointsSelection: false,
      filter: {
        type: 'none',
      },
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      borderRadiusApplication: 'end',
      borderRadiusWhenStacked: 'last',
    },
  },
  xaxis: {
    tooltip: { enabled: false },
    labels: {
      rotate: -45,
      rotateAlways: false,
      hideOverlappingLabels: true,
      style: { fontSize: '11px' },
    },
  },
  yaxis: {
    labels: {
      style: { fontSize: '11px' },
    },
  },
  legend: {
    markers: {
      shape: 'circle',
    },
  },
};
